const DEFAULT_GUARDIAN_CITIZENSHIP = "USA";

/**
 * Match the citizenship dropdown default (shows USA when unset) when sending API payloads.
 */
export function guardianCitizenshipForPayload(citizenship) {
  if (citizenship == null || String(citizenship).trim() === "") {
    return DEFAULT_GUARDIAN_CITIZENSHIP;
  }
  return citizenship;
}

export function normalizeGuardianForPayload(guardian) {
  if (!guardian || typeof guardian !== "object") {
    return guardian;
  }
  return {
    ...guardian,
    guardian_citizenship: guardianCitizenshipForPayload(
      guardian.guardian_citizenship
    ),
  };
}

export function normalizeGuardiansForPayload(guardians) {
  if (!Array.isArray(guardians)) {
    return guardians;
  }
  return guardians.map(normalizeGuardianForPayload);
}
